import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Message } from 'semantic-ui-react';
import { isInternalURL, flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import VideoEmbed from '@plone/volto/components/theme/VideoEmbed/VideoEmbed';
import config from '@plone/volto/registry';

//Extracting videoID, listID and thumbnailURL from the video URL
const getVideoIDAndPlaceholder = (url, peertubeInstances) => {
  let hasMatch = false;
  let videoID = null;
  let listID = null;
  let thumbnailURL = null;
  let videoSource = null;
  let videoUrl = null;

  if (url) {
    if (
      /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com|youtube-nocookie\.com|youtu\.be)(?:\/|$)/i.test(
        url,
      )
    ) {
      videoSource = 'youtube';
      const parsed = new URL(
        /^https?:\/\//i.test(url) ? url : `https://${url}`,
      );
      const path = parsed.pathname.split('/').filter(Boolean);
      videoID =
        parsed.searchParams.get('v') ||
        (parsed.hostname === 'youtu.be'
          ? path[0]
          : ['embed', 'shorts', 'live'].includes(path[0])
            ? path[1]
            : null);
      listID = parsed.searchParams.get('list');
      hasMatch = Boolean(videoID || listID);
      if (listID) {
        videoUrl = `https://www.youtube-nocookie.com/embed/videoseries?list=${encodeURIComponent(listID)}`;
      }
      if (videoID) {
        //load video preview image from youtube
        thumbnailURL =
          'https://img.youtube.com/vi/' + videoID + '/maxresdefault.jpg';
      }
    } else if (url.match('vimeo')) {
      hasMatch = true;
      videoSource = 'vimeo';
      videoID = url.match(/^.*\.com\/(.*)/)[1];
      if (videoID) {
        let thumbnailID = videoID;
        if (videoID.match(/\?si=/)) {
          thumbnailID = videoID.match(/(.*)\?si=(.*)/)[1];
        }
        thumbnailURL = 'https://vumbnail.com/' + thumbnailID + '.jpg';
      }
    } else if (
      url &&
      Array.isArray(peertubeInstances) &&
      url.match(new RegExp(peertubeInstances.join('|'), 'gi'))
    ) {
      const peertubeRegex = /^(https?:\/\/[^/]+)\/w\/([A-Za-z0-9_-]+)/i;
      const match = url.match(peertubeRegex);
      if (match) {
        hasMatch = true;
        videoSource = 'peertube';
        const instance = match[1];
        videoID = match[2];
        videoUrl = `${instance}/videos/embed/${videoID}`;
      }
    }
  }
  return { videoID, videoUrl, thumbnailURL, videoSource, hasMatch, listID };
};
const Body = ({ data, isEditMode }) => {
  let placeholder = data.preview_image
    ? isInternalURL(data.preview_image)
      ? `${flattenToAppURL(data.preview_image)}/@@images/image`
      : data.preview_image
    : null;
  const peertubeInstances =
    config.blocks.blocksConfig.video.allowedPeertubeInstances;

  const { videoID, videoUrl, thumbnailURL, videoSource, hasMatch } =
    getVideoIDAndPlaceholder(data.url, peertubeInstances);

  placeholder = !placeholder ? thumbnailURL : placeholder;
  const embedSettings = {
    placeholder: placeholder,
    aspectRatio: '16:9',
    title: data.title,
    copyright: data.copyright,
    isEditMode,
    id: videoID,
    source: videoSource,
    url: videoUrl,
  };

  return (
    <>
      {data.url && (
        <figure className="video-inner">
          {hasMatch ? (
            <VideoEmbed key={data.url} {...embedSettings} />
          ) : (
            <>
              {data.url.match('.mp4') ? (
                // eslint-disable-next-line jsx-a11y/media-has-caption
                <video
                  src={
                    isInternalURL(data.url)
                      ? data.url.includes('@@download')
                        ? data.url
                        : `${flattenToAppURL(data.url)}/@@download/file`
                      : data.url
                  }
                  controls
                  preload="none"
                  aria-label={data.title || 'Video'}
                  poster={placeholder}
                  type="video/mp4"
                />
              ) : isEditMode ? (
                <div>
                  <Message>
                    <center>
                      <FormattedMessage
                        id="Please enter a valid URL by deleting the block and adding a new video block."
                        defaultMessage="Please enter a valid URL by deleting the block and adding a new video block."
                      />
                    </center>
                  </Message>
                </div>
              ) : (
                <div className="invalidVideoFormat" />
              )}
            </>
          )}
          {data.title && (
            <figcaption className="bonn-video-caption">{data.title}</figcaption>
          )}
        </figure>
      )}
    </>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Body;
export { getVideoIDAndPlaceholder };
